import React, { useState, useContext, useEffect } from 'react'
import FieldsView from '@/custom/components/organisms/User/FieldView'
import { dateTimeFormatFunction } from '@/product/common/components'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
import Layout from '@/product/components/templates/Layout'
import { useHistory } from 'react-router-dom'
import { handleRedirectInternal } from '@/product/common/components'

const UserCommon = (props) => {
    const dynamicContext = useContext(DynamicContext)
    const [manage, setManage] = useState({
        popup: false,
        status: 'new',
        id: 0,
        secondaryID: 0,
        user_type: 0,
    })

    const { user_dynamicfields } = dynamicContext
    const history = useHistory()

    const [updatedValues, setUpdatedValues] = useState({})

    const [fieldValue, setFieldValue] = useState([])

    const customInitial = {
        id: 0,
        admin: 0,
    }
    useEffect(() => {
        if (props?.match?.params?.id && props?.match?.params?.status) {
            setManage({
                popup: true,
                status: props?.match?.params?.status,
                id: props?.match?.params?.id,
                user_type: 0,
                // secondaryID: props?.match?.params?.sid,
            })
        }
    }, [props?.match?.params?.id, props?.match?.params?.status])

    useEffect(() => {
        if (user_dynamicfields && user_dynamicfields.length) {
            let dynamicValueAssign = []
            user_dynamicfields.forEach((item) => {
                // Update the content if name is 'misc_password'
                if (item.name === 'misc_password') {
                    item.content = 'Password and Membership Details'
                }
                // if (item.name === 'email' || item.name === 'username') {
                //     item.disabled = true
                // }
                if (item.name === 'approved_seller') {
                    item.initialDefault = 343
                }
                if (item.name === 'retailer') {
                    item.initialDefault = 345
                }
                if (item.name === 'multibox_lisiting') {
                    item.initialDefault = 347
                }
                if (item.name === 'partialbox_listing') {
                    item.initialDefault = 349
                }
                // if (item.name == 'zip') {
                //     item.disabled = true
                // }
                // if (item.name == 'address1') {
                //     item.disabled = true
                // }
                // if (item.name == 'address2') {
                //     item.disabled = true
                // }
                // if (item.name == 'city') {
                //     item.disabled = true
                // }
                // if (item.name == 'state') {
                //     item.disabled = true
                // }

                // Check if item should be added to dynamicValueAssign
                if (item.view_on) {
                    if (item.view_on.includes('3')) {
                        dynamicValueAssign.push(item)
                    }
                } else {
                    // If item.view_on is undefined or falsy, push to dynamicValueAssign
                    dynamicValueAssign.push(item)
                }
            })

            dynamicValueAssign.push({
                name: 'market_status',
                value: 'draft',
                type: 'default',
                active: 1,
            })
            if (props?.match?.params?.id == 0) {
                const temp = dynamicValueAssign.filter((item) => {
                    return (
                        item.name != 'password' &&
                        item.name != 'confirm_password' &&
                        item.name != 'companyname' &&
                        item.name != 'phone' &&
                        item.name != 'reenter_email_address' &&
                        item.name != 'zip' &&
                        item.name != 'address1' &&
                        item.name != 'address2' &&
                        item.name != 'city' &&
                        item.name != 'state' &&
                        item.name != 'country' &&
                        item.name != 'misc_address' &&
                        item.name != 'seller_restrict' &&
                        item.name != 'user_restrict' &&
                        item.for_buyer === 1
                    )
                })
                setFieldValue(temp)
            } else {
                const temp = dynamicValueAssign.filter((item) => {
                    return (
                        item.name != 'password' &&
                        item.name != 'confirm_password' &&
                        item.name != 'companyname' &&
                        item.name != 'phone' &&
                        item.name != 'reenter_email_address' &&
                        item.name != 'zip' &&
                        item.name != 'address1' &&
                        item.name != 'address2' &&
                        item.name != 'city' &&
                        item.name != 'state' &&
                        item.name != 'country' &&
                        item.name != 'misc_address' &&
                        item.name != 'seller_restrict' &&
                        item.for_buyer === 1
                    )
                })
                setFieldValue(temp)
            }
        }
    }, [user_dynamicfields, props?.match?.params?.id])

    const closeFunction = () => {
        history.goBack()
    }

    const additionalFieldUpdate = (data) => {
        setUpdatedValues(data)
    }
    return (
        <>
            <Layout>
                <FieldsView
                    fieldValue={fieldValue}
                    data={manage}
                    customInitial={customInitial}
                    changePassword={true}
                    function={closeFunction}
                    additionalFieldUpdate={additionalFieldUpdate}
                    standalone={true}
                />
            </Layout>
        </>
    )
}

export default UserCommon
